// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/user/components/modals/tabs/components/AudioLevelMeter.module.css';
import {useEffect, useRef} from 'react';

interface AudioLevelMeterProps {
	level: number;
	thresholdPercent?: number;
	showThreshold?: boolean;
}

function getMeterColor(level: number): string {
	if (level < 0.6) return 'hsl(142, 71%, 45%)';
	if (level < 0.85) return 'hsl(48, 96%, 53%)';
	return 'hsl(0, 72%, 51%)';
}

export function AudioLevelMeter({level, thresholdPercent, showThreshold = false}: AudioLevelMeterProps) {
	const fillRef = useRef<HTMLDivElement>(null);
	const markerRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (fillRef.current) {
			fillRef.current.style.width = `${Math.min(100, Math.max(0, level * 100))}%`;
			fillRef.current.style.backgroundColor = level > 0 ? getMeterColor(level) : 'var(--text-tertiary)';
		}
	}, [level]);
	useEffect(() => {
		if (markerRef.current && thresholdPercent != null) {
			markerRef.current.style.left = `${Math.min(100, Math.max(0, thresholdPercent))}%`;
		}
	}, [thresholdPercent]);
	return (
		<div className={styles.track} data-flx="user.audio-level-meter.track">
			<div ref={fillRef} className={styles.fill} data-flx="user.audio-level-meter.fill" />
			{showThreshold && (
				<div ref={markerRef} className={styles.marker} aria-hidden="true" data-flx="user.audio-level-meter.marker" />
			)}
		</div>
	);
}
